'use strict';

const Carousel = require('./lib/carousel');

module.exports = Carousel;
